import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const NetworkStatusContext = createContext({
  isOffline: false,
  wasOffline: false,
});

export function NetworkStatusProvider({ children }) {
  const [isOffline, setIsOffline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine === false : false,
  );
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    function handleOffline() {
      setIsOffline(true);
      setWasOffline(true);
    }

    function handleOnline() {
      setIsOffline(false);
    }

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  const value = useMemo(
    () => ({
      isOffline,
      wasOffline,
      clearWasOffline: () => setWasOffline(false),
    }),
    [isOffline, wasOffline],
  );

  return (
    <NetworkStatusContext.Provider value={value}>
      {children}
    </NetworkStatusContext.Provider>
  );
}

export function useNetworkStatus() {
  return useContext(NetworkStatusContext);
}